import { __assign } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import SvgIcon from '../Icons/SvgIcon';

var Corner = function Corner(props) {
  return _jsx(SvgIcon, __assign({
    width: "10",
    height: "5",
    viewBox: "0 0 10 5"
  }, props, {
    children: _jsx("path", {
      d: "M5 0C3 5 0 5 0 5H10C10 5 7 5 5 0Z"
    })
  }));
};

export default Corner;